"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.decode = exports.eitherFromUnion = void 0;
var Either_1 = require("fp-ts/lib/Either");
var io_ts_types_1 = require("io-ts-types");
var function_1 = require("fp-ts/lib/function");
var t = __importStar(require("io-ts"));
var to_error_1 = __importDefault(require("to-error"));
var Either_2 = require("fp-ts/lib/Either");
var eitherFromUnion = function (leftCodec, rightCodec, name) {
    if (name === void 0) { name = "EitherFromUnion<" + leftCodec.name + ", " + rightCodec.name + ">"; }
    var e = io_ts_types_1.either(leftCodec, rightCodec);
    return new t.Type(name, e.is, function (input, _) {
        var rightResult = function_1.pipe(input, rightCodec.decode, Either_1.map(function (a) { return Either_1.right(a); }));
        var leftResult = function_1.pipe(input, leftCodec.decode, Either_1.map(function (a) { return Either_1.left(a); }));
        return function_1.pipe(rightResult, Either_1.fold(function_1.constant(leftResult), t.success));
    }, function (value) {
        return function_1.pipe(value, Either_1.fold(function_1.identity, function_1.identity));
    });
};
exports.eitherFromUnion = eitherFromUnion;
var decode = function (T, data) {
    return function_1.pipe(data, T.decode, Either_2.mapLeft(to_error_1["default"]));
};
exports.decode = decode;
